var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0007 11.0005C16.0007 8.25045 18.3132 5.96295 21.0632 6.00045C22.0262 6.01157 22.9656 6.3006 23.7683 6.8328C24.571 7.365 25.203 8.11771 25.5882 9.00045H30.0007L25.9632 13.038C25.7026 17.0937 23.9073 20.8979 20.9422 23.6773C17.9771 26.4566 14.0648 28.0025 10.0007 28.0005C6.00068 28.0005 5.00068 26.5005 5.00068 26.5005C5.00068 26.5005 9.00068 25.0005 11.0007 22.0005C11.0007 22.0005 3.00068 18.0005 5.00068 7.00045C5.00068 7.00045 10.0007 12.0005 16.0007 13.0005V11.0005Z",
    stroke: "#858584",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.5d141ef7e34aa13d6009a0746c048d78.svg";
export { ForwardRef as ReactComponent };